(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.faq__item').forEach(function (item) {
      var trigger = item.querySelector('.faq__trigger');
      var body = item.querySelector('.faq__body');
      if (!trigger || !body) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.toggle('faq__item--open');
        body.style.maxHeight = isOpen ? body.scrollHeight + 'px' : '0';
        body.style.opacity = isOpen ? '1' : '0';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var cartBtn = document.getElementById('HeaderCartBtn');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        if (cartBtn.dataset.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('cart:open'));
        } else {
          window.location.href = cartBtn.dataset.cartUrl;
        }
      });
    }

    // Sous-menus (Aide, etc.) : le survol ouvre déjà le panneau en CSS pur sur
    // desktop, mais un clic/tap est nécessaire pour le clavier, le tactile, et
    // pour empêcher le lien parent de naviguer puisqu'il n'a pas de page à lui.
    var navDropdowns = document.querySelectorAll('[data-nav-dropdown]');
    navDropdowns.forEach(function (item) {
      var trigger = item.querySelector('.header__nav-link--parent, .mobile-menu__link--parent');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('is-open');
        navDropdowns.forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('.header__nav-link--parent, .mobile-menu__link--parent');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });
        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    document.addEventListener('click', function (e) {
      navDropdowns.forEach(function (item) {
        if (!item.contains(e.target)) {
          item.classList.remove('is-open');
          var trigger = item.querySelector('.header__nav-link--parent, .mobile-menu__link--parent');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      navDropdowns.forEach(function (item) {
        item.classList.remove('is-open');
        var trigger = item.querySelector('.header__nav-link--parent, .mobile-menu__link--parent');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    });

    // Compact header (toutes pages) : réduit hauteur + logo après 80px de scroll
    var anyGroup = document.querySelector('.header-group');
    if (anyGroup) {
      var applyCompact = function () {
        if (window.scrollY > 80) {
          anyGroup.classList.add('is-compact');
        } else {
          anyGroup.classList.remove('is-compact');
        }
      };
      window.addEventListener('scroll', applyCompact, { passive: true });
      applyCompact();
    }

    // En-tête transparent (page d'accueil) : bascule is-solid après le hero
    var group = document.querySelector('.header-group--overlay');
    if (group) {
      var onScroll = function () {
        if (window.scrollY > window.innerHeight * 0.65) {
          group.classList.add('is-solid');
        } else {
          group.classList.remove('is-solid');
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Menu mobile (hamburger)
    var menuToggle = document.getElementById('HeaderMenuToggle');
    var menuDialog = document.getElementById('HeaderMobileMenu');
    if (menuToggle && menuDialog) {
      var isDropdown = menuDialog.classList.contains('mobile-menu--dropdown');
      var headerEl = document.querySelector('.header');

      var openMenu = function () {
        if (isDropdown && headerEl) {
          menuDialog.style.top = headerEl.getBoundingClientRect().bottom + 'px';
          menuDialog.style.maxHeight = 'calc(100vh - ' + headerEl.getBoundingClientRect().bottom + 'px)';
        }
        menuDialog.showModal();
        menuToggle.classList.add('is-open');
        menuToggle.setAttribute('aria-expanded', 'true');
        // Deux frames d'écart avec showModal() pour que la transition CSS
        // (état fermé → .is-open) soit bien jouée par le navigateur.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            menuDialog.classList.add('is-open');
          });
        });
      };

      var closeMenu = function () {
        menuDialog.classList.remove('is-open');
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          menuDialog.removeEventListener('transitionend', finish);
          if (menuDialog.open) menuDialog.close();
        };
        menuDialog.addEventListener('transitionend', finish);
        setTimeout(finish, 350);
      };

      menuToggle.addEventListener('click', function () {
        if (menuDialog.open) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      var closeBtn = menuDialog.querySelector('[data-mobile-menu-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeMenu);

      menuDialog.addEventListener('click', function (e) {
        if (e.target === menuDialog) closeMenu();
      });

      menuDialog.querySelectorAll('.mobile-menu__link').forEach(function (link) {
        link.addEventListener('click', function () {
          menuDialog.classList.remove('is-open');
        });
      });

      // Filet de sécurité : quelle que soit la façon dont le <dialog> se
      // ferme (Échap, close(), etc.), on resynchronise toujours l'état visuel.
      menuDialog.addEventListener('close', function () {
        menuDialog.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    }

    var rotator = document.querySelector('.announce__rotator');
    if (rotator) {
      var items = rotator.querySelectorAll('.announce__item');
      if (items.length > 1) {
        var current = 0;
        var speed = parseInt(rotator.getAttribute('data-speed'), 10) || 4000;
        setInterval(function () {
          items[current].classList.remove('is-active');
          current = (current + 1) % items.length;
          items[current].classList.add('is-active');
        }, speed);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offre"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var container = document.querySelector('[data-tiers]');
    if (!container) return;
    var tiers = container.querySelectorAll('.offre__tier');
    var cartPrice = document.querySelector('[data-cart-price]');

    tiers.forEach(function(tier) {
      tier.addEventListener('click', function(e) {
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
        tiers.forEach(function(t) { t.classList.remove('offre__tier--selected'); });
        tier.classList.add('offre__tier--selected');
        if (cartPrice) {
          cartPrice.textContent = tier.getAttribute('data-now');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var thumbs = document.querySelectorAll('.pdp__thumb');
    var images = document.querySelectorAll('.pdp__image');
    if (!thumbs.length || !images.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = parseInt(this.dataset.index);
        thumbs.forEach(function(t) { t.classList.remove('pdp__thumb--active'); });
        images.forEach(function(img) { img.classList.remove('pdp__image--active'); img.style.display = 'none'; });
        this.classList.add('pdp__thumb--active');
        if (images[index]) {
          images[index].classList.add('pdp__image--active');
          images[index].style.display = 'block';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
